import { useState } from "react"
import { Link } from "react-router-dom"
import { Logo } from "../components"
import { footer, footerSocials } from "../data/data"
import SocialsLinks from './SocialsLinks'

export default function Footer() {
  const [items] = useState(footer)
  const [socials] = useState(footerSocials)

  return (
    <>
      <footer className="flex items-center justify-center flex-col text-center px-5 py-10 lg:py-20 2xl:px-0 xl:max-w-6xl xl:mx-auto">
        <Logo />

        <nav className="my-10">
          <ul className="md:flex flex-wrap justify-center">
            {items.map(({ id, title, url }) => (
              <li
                key={id}
                className="footer-links text-xl my-5 md:mx-5 lg:text-2xl lg:mx-7"
              >
                <Link to={url}>{title}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h4 className="text-2xl mb-5">Follow us</h4>
          <SocialsLinks />
        </div>
      </footer>
      <div className="bg-gray-300 text-center py-2 px-5 2xl:px-0 lg:py-3">
        <p>Copyright © 2026 Be Brokers All Rights Reserved.</p>
      </div>
    </>
  )
}
